// extracted by mini-css-extract-plugin
export default {"normalButton":"Button_normalButton__LD1hz","funButton":"Button_funButton__HeDfW"};